class Nav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.body = document.body;

        self.navToggle = document.querySelector('[data-nav-toggle]');
        self.nav = self.elem.querySelector('[data-nav]');
        self.header = document.querySelector('[data-header]');
        self.navItem = self.elem.querySelectorAll('[data-primary-nav-item]');
        self.subNavs = document.querySelectorAll('[data-secondary-nav]');
    }

    init() {
        let self = this;

        self.toggleNav();
        self.toggleNavItems();
    }

    toggleNav() {
        let self = this;

        self.navToggle.addEventListener('click', evt => {
            // Scroll the nav to the top
            self.nav.scrollTop = 0;
            
            // Toggle active class on toggle button
            self.navToggle.classList.toggle('is-active');

            // Toggle transparent header
            self.header.classList.toggle('header--transparent');

            // Toggle active class on header
            self.elem.classList.toggle('nav-is-open');

            // Toggle scrolling on body
            self.body.classList.toggle('is-no-scroll');
        });
    }

    toggleNavItems() {
        let self = this;        

        self.navItem.forEach((item) => {
            const trigger = item.querySelector('[data-nav-primary-trigger]');
            const subNav = item.querySelector('[data-secondary-nav]');
            
            trigger.addEventListener("click", (evt) => {
                evt.preventDefault();

                // Toggle class on current trigger
                trigger.classList.toggle('is-active');
    
                // Show/hide current sub-nav
                subNav.classList.toggle('d-none');
            });
        });
    }
}

export default Nav;
